import 'deepmerge';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}

var ARModal = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"ar-modal",attrs:{"ar-widget-id":"ar-modal","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-modal"},on:{"mouseover":_vm.handleMouseOver,"mouseleave":_vm.handleMouseLeave}},[_c('div',{staticClass:"ar-modal-mask",on:{"click":_vm.handleMaskClick}}),_vm._v(" "),_c('div',{ref:"modal-content",class:[
      'ar-modal-content',
      _vm.mobile ? 'mobile' : 'desktop' ],style:(_vm.modalStyle)},[(_vm.hasBackLink)?_c('ar-link-button',{class:[
        'ar-modal-back-link',
        _vm.mobile ? 'mobile' : 'desktop' ],attrs:{"icon-name":"arrow","icon-props":{
        width: '6px',
        rotate: 90,
      },"text":"Back","color":_vm.modalThemeColor,"has-underline":false},on:{"click":_vm.handleBackLinkClick}}):_vm._e(),_vm._v(" "),(_vm.hasCrossIcon)?_c('ar-icon-button',{class:[
        'ar-modal-cross-icon',
        _vm.crossIconPosition === 'outside' && 'outside',
        _vm.mobile ? 'mobile' : 'desktop' ],attrs:{"icon-props":{
        name: 'cross-thick',
        height: _vm.crossIconHeight,
      },"color":_vm.crossIconPosition === 'outside' ? 'white' : _vm.$arStyle.color.blueGrey700,"hovered-color":_vm.modalThemeColor},nativeOn:{"click":function($event){return _vm.handleCloseClick($event)}}}):_vm._e(),_vm._v(" "),(!_vm.hideHeader)?_c('div',{ref:"header",class:[
        'ar-modal-header',
        _vm.mobile ? 'mobile' : 'desktop' ]},[(_vm.header)?_c('div',{style:({
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })},[_c('ar-text',{attrs:{"size":"md","text":_vm.header}})],1):_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{class:[
        'ar-modal-body',
        _vm.hideHeader && 'without-header',
        _vm.hideFooter && 'without-footer',
        _vm.noBodyOverflow && 'no-overflow'
      ]},[_c('div',{ref:"top-shadow",class:['ar-modal-body-shadow', 'top'],style:({
          top: 0,
          boxShadow: _vm.hasTopShadow ? ("inset 0 25px 14px -23px " + (this.$arStyle.color.blueGrey700)) : null,
        })}),_vm._v(" "),_c('div',{ref:"body-inner",class:[
          'ar-modal-body-inner',
          _vm.size,
          _vm.showScrollbars && 'show-scrollbars',
          !_vm.showScrollbars && 'hide-scrollbars',
          _vm.noBodyOverflow && 'no-overflow'
        ]},[_c('div',{ref:"body-wrapper",staticClass:"body-wrapper"},[_vm._t("body")],2)]),_vm._v(" "),_c('div',{ref:"bottom-shadow",class:['ar-modal-body-shadow', 'bottom'],style:({
          bottom: 0,
          boxShadow: _vm.hasBottomShadow ? ("inset 0 -25px 14px -23px  " + (this.$arStyle.color.blueGrey700)) : null,
        })})]),_vm._v(" "),(!_vm.hideFooter)?_c('div',{staticClass:"ar-modal-footer"},[_vm._t("footer")],2):_vm._e()],1)]):_vm._e()},
staticRenderFns: [],
  name: 'Modal',
  props: {
    arWidgetMeta: String,
    isOpen: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '1010px',
    },
    height: {
      type: String,
      default: null,
    },
    background: {
      type: String,
      default: 'white',
    },
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: null,
    },
    hasBackLink: {
      type: Boolean,
      default: false,
    },
    hasCrossIcon: {
      type: Boolean,
      default: true,
    },
    crossIconPosition: {
      type: String,
      default: 'inside',
      validator: (val) =>
        ['inside', 'outside'].indexOf(val) !== -1,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    closeOnBgClick: {
      type: Boolean,
      default: false,
    },
    noBodyOverflow: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      lockedWindowScrollY: null,
      hasTopShadow: false,
      hasBottomShadow: false,
      showScrollbars: false,
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [].join('');
    },
    modalThemeColor() {
      if (this.color === 'purple') {
        return this.$arStyle.color.purple500;
      } else {
        return this.color;
      }
    },
    crossIconHeight() {
      return this.crossIconPosition === 'outside' ? '24px' : '16px';
    },
    modalStyle() {
      if (this.mobile) {
        return {
          width: '100%',
          height: '100%',
          background: this.background,
        };
      } else {
        return {
          width: this.width,
          height: this.height,
          background: this.background,
        };
      }
    },
  },
  watch: {
    isOpen: {
      handler(val) {
        if (val) {
          window.addEventListener('scroll', this.handleScroll);
          this.$nextTick(() => {
            window.removeEventListener('resize', this.handleWindowResize);

            // Add listeners for shadows
            // We need to double up on these because of the two means we use to initialise modals. Once modals are all uniformly initialised, we can axe one of these init methods
            if (this.$refs['body-inner']) this.$refs['body-inner'].removeEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleWindowResize);
            if(this.$refs['body-inner']) this.$refs['body-inner'].addEventListener('scroll', this.handleScroll);
            this.handleScroll(null);
          });
          setTimeout(() => {
            this.checkScrollbars();
          }, 50);
        } else {
          window.removeEventListener('scroll', this.handleScroll);

          // Remove listeners for shadows
          // We need to double up on these because of the two means we use to hide modals. Once modals are all uniformly hidden, we can axe one of these init methods
          window.removeEventListener('resize', this.handleWindowResize);
          if (this.$refs['body-inner']) this.$refs['body-inner'].removeEventListener('scroll', this.handleScroll);
          window.addEventListener('resize', this.handleWindowResize);
          if(this.$refs['body-inner']) this.$refs['body-inner'].addEventListener('scroll', this.handleScroll);
        }
      },
      immediate: true,
    },
    headerProps: {
      handler(val) {
        this.$nextTick(() => {
          this.handleScroll(null);
        });
      },
      deep: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('popstate', this.handleHistoryChange);

    // Add listeners for shadows
    // We need to double up on these because of the two means we use to initialise modals. Once modals are all uniformly initialised, we can axe one of these init methods
    window.addEventListener('resize', this.handleWindowResize);
    if(this.$refs['body-inner']) this.$refs['body-inner'].addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      this.handleScroll(null);
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('popstate', this.handleHistoryChange);

    // Remove listeners for shadows
    // We need to double up on these because of the two means we use to hide modals. Once modals are all uniformly hidden, we can axe one of these init methods
    window.removeEventListener('resize', this.handleWindowResize);
    if (this.$refs['body-inner']) this.$refs['body-inner'].removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // Do not take this out, it's being used by other repos
    scrollToTop() {
      if (this.$refs['body-inner']) {
        this.$refs['body-inner'].scrollTop = 0;
      }
    },
    handleScroll(e) {
      if (this.lockedWindowScrollY !== null && !!e) {
        e.preventDefault();
        window.scrollTo(window.scrollX, this.lockedWindowScrollY);
      }

      if (!this.$refs['body-inner'] || !this.$refs['body-wrapper']) return;
      this.hasTopShadow = this.$refs['body-inner'].scrollTop > 0;
      this.hasBottomShadow = (this.$refs['body-inner'].scrollTop + this.$refs['body-inner'].offsetHeight + 1) < this.$refs['body-wrapper'].scrollHeight;
    },

    handleMouseOver() {
      this.lockedWindowScrollY = window.scrollY;
    },
    handleMouseLeave() {
      this.lockedWindowScrollY = null;
    },
    handleCloseClick() {
      this.$emit('close');
    },
    handleMaskClick() {
      if (this.closeOnBgClick) {
        this.$emit('close');
      }
    },
    handleBackLinkClick() {
      this.$emit('back');
    },
    handleHistoryChange() {
      if (this.isOpen) {
        this.$emit('close');
      }
    },
    checkScrollbars(){
      if (!this.$refs['body-wrapper'] || !this.$refs['body-inner'] ) {
        return;
      }
      // Body wrapper wraps the body <slot>, which will always be the height of the content
      // Currently adding 60px to account for standard margin of body <slot> - need a way to read the margin attached to it
      if (this.$refs['body-wrapper'].clientHeight === this.$refs['body-inner'].clientHeight) {
        this.showScrollbars = false;
      } else {
        this.showScrollbars = (this.$refs['body-wrapper'].clientHeight + 60) > this.$refs['body-inner'].clientHeight;
      }
    },
    handleWindowResize(e) {
      this.handleScroll(e);
      this.checkScrollbars();
    },
  },
};

export default ARModal;
